import { useMemo } from "react";
import { IPageData } from "../types/IPageData";

export function usePageData() {
  const pageData = useMemo<IPageData>(() => {
    const pageData: string[] = window.location.href.split("/");
    let pageUrl: string[] = [];

    const res: IPageData = {
      domain: "",
      pageRoot: "",
      pageType: "",
      pageId: "",
      articleId: "",
      text: "",
    };

    if (pageData[4]) {
      pageUrl = pageData[4].split(",");
    }

    if (pageData[2]) {
      res.domain = pageData[2];
    }

    if (pageData[3]) {
      res.pageRoot = pageData[3];
    }

    if (pageUrl[0]) {
      res.pageType = pageUrl[0];
    }

    if (pageUrl[1]) {
      res.pageId = pageUrl[1];
    }

    if (pageUrl[2]) {
      res.articleId = pageUrl[2].split(".")[0];
    }

    if (pageUrl[3]) {
      res.text = pageUrl[3].split(".")[0];
    }

    return res;
  }, []);

  return pageData;
}
